import { Link } from "react-router-dom";
import { TableCell, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { ExternalLink } from "lucide-react";
import { PriorityBadge, StatusBadge } from "@/components/Badges";
import ChannelPill from "@/components/settings/ChannelPill";
import { ticketTypeMeta } from "@/lib/ticketType";

/**
 * Single ticket row for the Tickets list table.
 * Presentational — all data + handlers come from props.
 */
export default function TicketRow({
  t, channels, canBulk, canViewAssignee, selected, onToggle, fmt,
}) {
  const tm = ticketTypeMeta(t.ticket_type);
  return (
    <TableRow
      className={`hover:bg-slate-50 ${tm ? `border-l-[3px] ${tm.leftBar}` : ""}`}
      data-testid={`ticket-row-${t.code}`}
    >
      {canBulk && (
        <TableCell>
          <Checkbox
            checked={selected}
            onCheckedChange={() => onToggle(t.id)}
            data-testid={`select-${t.code}`}
          />
        </TableCell>
      )}
      <TableCell>
        <div className="flex items-center gap-1.5">
          <a
            href={`/tickets/${t.id}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Open in new tab"
            aria-label={`Open ${t.code} in new tab`}
            onClick={(e) => e.stopPropagation()}
            className="text-slate-400 hover:text-indigo-600 transition-colors shrink-0"
            data-testid={`ticket-newtab-${t.code}`}
          >
            <ExternalLink className="w-3.5 h-3.5" strokeWidth={2.2} />
          </a>
          {tm && <tm.icon className={`w-3.5 h-3.5 ${tm.iconColor} shrink-0`} strokeWidth={2.2} aria-label={tm.label} />}
          <Link to={`/tickets/${t.id}`} className="text-indigo-600 font-mono text-xs font-medium">{t.code}</Link>
        </div>
      </TableCell>
      <TableCell className="max-w-[280px] truncate text-sm font-medium text-slate-800">
        <Link to={`/tickets/${t.id}`}>{t.subject}</Link>
      </TableCell>
      <TableCell className="text-sm">{t.customer_name}</TableCell>
      <TableCell className="text-xs text-slate-600">
        <ChannelPill channel={channels.find((c) => c.name === t.channel)} name={t.channel} />
      </TableCell>
      <TableCell className="text-xs text-slate-600 max-w-[180px] truncate">
        {t.category}{t.subcategory ? ` → ${t.subcategory}` : ""}
      </TableCell>
      <TableCell className="text-xs text-slate-600 max-w-[160px] truncate">{t.department_name || "—"}</TableCell>
      <TableCell><PriorityBadge value={t.priority} /></TableCell>
      <TableCell><StatusBadge value={t.status} /></TableCell>
      {canViewAssignee && <TableCell className="text-xs text-slate-600">{t.owner_email}</TableCell>}
      <TableCell className="text-right text-xs text-slate-500">{fmt(t.created_at)}</TableCell>
    </TableRow>
  );
}
